// extracted by mini-css-extract-plugin
export default {"root":"styles_root__5mJDH","title":"styles_title__N72ou"};